// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"a9501ebe","12":"bff190f8","52":"e229e646","230":"7cecd3e2","378":"e4998bbb","890":"1d39c9fb"}[chunkId] + ".chunk.js";
};